const yup = require("yup");

// Schema for createcollegerules
const createModuleRules = yup.object({
  programme: yup.string().min(2, "Minimum of 2 characters expected").required("Department is required"),
  code: yup.string().min(2, "Minimum of 2 characters expected").required("Code is required"),
  name: yup.string().min(2, "Minimum of 2 characters expected").required("Name is required"),
  moduletype: yup.string().min(2, "Minimum of 2 characters expected").required("Module type is required"),
  status: yup.boolean().required("Status is required"),
  credit: yup.number().required("Credit load is required"),
  level: yup.string().required("Level is required"),
  general: yup.boolean().required("College wide module is required"),
  semester: yup.string().required("Semester is required"),
});

module.exports = {
  createModuleRules,
};
